module.exports = Em.Mixin.create
  resetController: ->
    @_super(arguments...)
    @get('controller')?.teardown?()
